import React, { Component } from "react";
import {
    NavBar,
    Icon,
    InputItem,
    List,
    Picker,
    Button,
    WhiteSpace,
    WingBlank,
    Checkbox,
    DatePickerView,
    Modal,
    TextareaItem,
    Toast,
    Accordion,
    Badge,
    ActionSheet,
    Radio
} from "antd-mobile";
import { createForm } from "rc-form";
import moment from "moment";
import "./userAdd.scss";
import axios from "@/service/axios";
import { connect } from "dva";
import UserSelectGroups from "./userSelectGroup";
import { formDateTime } from "../../../utils/common";
import DefaultGroup from "./defaultGroup";
import { get } from "lodash";
const Item = List.Item;
const CheckboxItem = Checkbox.CheckboxItem;
const RadioItem = Radio.RadioItem;
const loginAdminMsg =
    sessionStorage.getItem("loginMsg") &&
    JSON.parse(sessionStorage.getItem("loginMsg"));
const selectedContainer = {
    position: "fixed",
    width: "100%",
    top: "0px",
    background: "#f5f5f5",
    height: "100%",
    zIndex: "11",
    transition: "left 0.4s",
};
const GpsInterval = [
    {
        label: <div key="1">0s</div>,
        value: 0,
    },
    {
        label: <div key="2">1分钟</div>,
        value: 60,
    },
    {
        label: <div key="3">5分钟</div>,
        value: 300,
    },
    {
        label: <div key="4">10分钟</div>,
        value: 600,
    },
];
@connect()
export class AddUser extends Component {
    state = {
        userInfo: {
            gpsInterval: 60,
            deviceInfo:{
                iccid: '',
                imei: '',
                version: ''
            }
        },
        type: this.props.match.params.type,
        drawerLeft: document.body.clientWidth,
        drawerLeftDefault: document.body.clientWidth,
        showDivDefaultGroup: "block",
        funcGidArr: [],
        funcsList: [],
        showValidateMonths: true,
        preValidateMonth: -1,
        totalPrice: 0,
        permanentTotalPrice: 0,
        checkedFuncGidArr: [],
        hideDeleteBtn: true,
        renewType: 0,
        funcValueList: [],
        funcs2: [],
        dateTime1:null,
        dateTime2:null,
        modalStartFlag:false,
        modalEndFlag:false,
        startTime:'',
        endTime:'',
        months: 1,
        checkRadioItem: [],
        userType: 0,
        funcGroupPrice: 0,
        userValidYears: 0,
    };
    async componentDidMount() {
        this.props.emptyGroups();
        await this.props.getFuncList();
        Toast.loading("加载中...", 10);
        if (this.props.match.params.type == "edit") {
            await this.getUserIsIngroup();
            await this.getUserInfo();
        } else {
            this.getPreValidateMonth();
            this.getAdminUserValidYears();
        }
        this.setState({
            dateTime1:new Date(Date.parse(new Date())),
            dateTime2:new Date(Date.parse(new Date())+3600000)
        })
    }
    //获取总管理员的优惠时间
    getPreValidateMonth() {
        return new Promise((resolve, reject) => {
            axios.get("/api/user/admin/preferentialMonths/get").then(res => {
                if (res.status == 200 && res.data) {
                    if (res.data >= 0) {
                        this.setState({
                            preValidateMonth: res.data,
                        });
                    }
                }
            });
        });
    }
    getAdminUserValidYears(){
        return new Promise((resolve, reject) => {
            axios.get("/api/user/admin/validYears/get").then(res => {
                if (res.status == 200 && res.data) {
                    if (res.data >= 0) {
                        this.setState({
                            userValidYears: res.data,
                        });
                    }
                }
            });
        })
    }
    apiGetAdminUserValidYears
    //确定提交
    submitBtn() {
        console.log(22222);
        this.props.form.validateFields({ force: true }, error => {
            console.log(error);
            if (!error) {
                const fildsValue = this.props.form.getFieldsValue();
                const preferentialMonths = this.state.preValidateMonth;
                const { validMonths } = fildsValue
                let funcsList = []
                if(this.props.match.params.type == 'edit'){} else {
                    // console.log('!!!!!!!!!!')
                    funcsList = [this.state.checkRadioItem]
                }   
                let params = {
                    ...fildsValue,
                    defaultGid: this.props.defaultGroup.gid,
                    joinGids: this.props.groupsGidArr,
                    gpsInterval: fildsValue.gpsInterval[0],
                    remarks: fildsValue.remarks || null,
                    name: fildsValue.name || "",
                    imei: fildsValue.imei || "",
                    count: fildsValue.create_number || undefined,
                    uid: this.props.match.params.id,
                    validMonths: preferentialMonths > 0 ? preferentialMonths : validMonths,
                    funcValueList: this.state.funcValueList,
                    funcsList: funcsList,
                    type: this.state.userType,
                };
                console.log('params~~~',params)
                Toast.loading("加载中...", 10);
                let type =
                    this.props.match.params.type == "edit" ? "update2" : "add2";
                axios
                    .post("/api/user/ptt/" + type, {
                        ...params,
                    })
                    .then(res => {
                        console.log(res);
                        if (res) {
                            if (res.status == 200) {
                                this.props.emptyGroups();
                                Toast.success(res.message, 2, () => {
                                    // this.props.history.replace("/userlist");
                                    window.history.go(-1);
                                });
                            } else if (res.status == 392) {
                                Toast.fail("虚拟币不足");
                            }
                            else {
                                Toast.fail(res.message);
                            }
                        }
                    });
            }
        });
    }
    //获取用户所属群组
    getUserIsIngroup() {
        return new Promise(rev => {
            axios
                .post("/api/user/ptt/groups", {
                    page: { pageNo: 1, pageSize: 2500 },
                    uid: this.props.match.params.id,
                })
                .then(res => {
                    rev();
                    if (res && res.status == 200 && res.data) {
                        this.props.setGroups(res.data.resultList);
                    }
                })
                .catch(() => {
                    Toast.hide();
                });
        });
    }
    //编辑用户时候获取用户的信息
    getUserInfo() {
        return new Promise(rev => {
            axios
                .get("/api/user/ptt/find2/id", {
                    params: {
                        uid: this.props.match.params.id,
                    },
                })
                .then(res => {
                    console.log(res);
                    rev();
                    if (res && res.status == 200 && res.data) {
                        let data = {
                            ...res.data,
                            defaultGroup: {
                                name: res.data.defaultGidName,
                                gid: res.data.defaultGid,
                            },
                        };
                        this.props.addDefaultGroup({
                            name: res.data.defaultGroupName,
                            gid: res.data.defaultGid,
                        });

                        this.props.form.setFieldsValue({
                            funcsList: data.funcsList,
                        });
                        //判断是否为1年折扣用户
                        const isBefore = moment(data.validDate).isBefore(data.maxValidDate);
                        this.setState({
                            userInfo: data,
                            renewType: data.oldType == 6 && isBefore ? 1 : 0,
                        });
                        //折扣账号7天内可以删除
                        if (loginAdminMsg && loginAdminMsg.permissionCodeList.includes(202)
                            && !moment(data.createDate).isBefore(moment(new Date()).subtract('days', 7))) {
                            this.setState({
                                hideDeleteBtn: false,
                            });
                        }
                        this.setState({
                            funcValueList: data.funcValueList || [],
                        });
                        //录音定位套餐
                        const funcs22 = [{ id: -1, code: 4, name: "录音", remarks: "录音记录保存15天" }, { id: -2, code: 101, name: "定位", remarks: "定位数据保存15天" }]
                        this.setState({
                            funcs2: funcs22.filter(i => data.includes(i.code)),
                        })
                    }
                })
                .catch(() => {
                    Toast.hide();
                });
            axios.get("/api/user/ptt/functions/get", {
                params: {
                    uid: this.props.match.params.id,
                },
            }).then(res => {
                console.log(res);
                rev();
                if (res && res.status == 200 && res.data) {
                    //录音定位套餐
                    const funcs22 = [{ id: -1, code: 4, name: "录音", remarks: "录音记录保存15天" }, { id: -2, code: 101, name: "定位", remarks: "定位数据保存15天" }]
                    this.setState({
                        funcs2: funcs22.filter(i => res.data.includes(i.code)),
                    })
                }
            }).catch(() => {
            });
        });
    }

    deleteBtn() {
        const BUTTONS = ["确定", "取消"];
        ActionSheet.showActionSheetWithOptions(
            {
                options: BUTTONS,
                message: "是否删除选中的用户？",
                maskClosable: true,
                "data-seed": "logId",
            },
            async buttonIndex => {
                if (!buttonIndex) {
                    this.deleteUser();
                }
            },
        );
    }

    //删除用户
    deleteUser() {
        axios
            .post("/api/user/ptt/delete2", {
                uids: Array.of(this.props.match.params.id),
            })
            .then(res => {
                console.log(res);
                if (res.status == 200) {
                    Toast.success('删除成功', 2, () => {
                        // this.props.history.replace("/userlist");
                        window.history.go(-1);
                    });
                } else {
                    Toast.fail(res.message);
                }
            })
            .catch((err) => {
                Toast.fail(err);
            });
    }

    validateAccount = (rule, value, callback) => {
        if (value) {
            if (value.trim()) {
                const { form } = this.props;
                let count = form.getFieldValue('create_number') || 1;
                let initNo = form.getFieldValue('initNo') || 1;
                let len1 = value.length;
                let len2 = Number(count) + Number(initNo) - 1;
                let strLength = len2.toString().padStart(3, "0")
                console.log(strLength)
                if (!/^[a-zA-Z0-9]{2,16}$/.test(value)) {
                    callback(new Error("账号只支持2-16位数字、字母或组合"));
                } else if (count > 1 && ((len1 + strLength.toString().length > 16))) {
                    callback("批量创建账号长度不超过16");
                } else {
                    callback();
                }
            } else {
                callback(new Error("请输入账号"));
            }
        } else {
            callback(new Error("请输入账号"));
        }
    };
    //名称校验
    validateName = (rule, value, callback) => {
        if (value) {
            if (value.trim()) {
                const { form } = this.props;
                let count = form.getFieldValue('create_number') || 1;
                let initNo = form.getFieldValue('initNo') || 1;
                let len1 = value.length;
                let len2 = Number(count) + Number(initNo) - 1;
                let strLength = len2.toString().padStart(3, "0")
                if (!/^[a-zA-Z0-9_\u4e00-\u9fa5]{0,16}$/.test(value)) {
                    callback(new Error("名字只支持0-16位的中文、数字、字母或下划线"));
                } else if (count > 1 && ((len1 + strLength.toString().length > 16))) {
                    callback("批量创建名称长度不超过16");
                } else {
                    callback();
                }
            } else {
                callback();
            }
        } else {
            callback();
        }
    };
    //验证密码
    validatePassword = (rule, value, callback) => {
        if (value) {
            if (
                /^[A-Za-z0-9]+$/gi.test(value) &&
                value.length <= 12 &&
                value.length >= 6
            ) {
                callback();
            } else {
                callback(new Error("请输入6-12位由数字和字母组成的密码"));
            }
        } else {
            callback(new Error("请输入密码"));
        }
    };
    //验证gps
    validateGpsinterval = (rule, value, callback) => {
        if (typeof value[0] == "number") {
            callback();
        } else {
            callback(new Error("请选择GPS上报周期"));
        }
    };
    //验证账号数
    validateCreateNumber = (rule, value, callback) => {
        console.log('valueeeeee', value)
        console.log('typeof value', typeof value)
        if (/^\d{1,3}$/.test(value) && value > 0 && value <= 500) {
            callback();
        } else {
            callback(new Error("请输入1~500的数字"));
        }
    };
    validateInGroups = (rule, value, callback) => {
        if (this.props.groups.length < 1) {
            callback(new Error("请选择用户所在群组"));
        } else {
            callback();
        }
    };
    validateDefaultGid = (rule, value, callback) => {
        let defaultGroup = this.props.defaultGroup;
        if (defaultGroup && defaultGroup.name) {
            callback();
        } else {
            callback(new Error("请选择用户默认群组"));
        }
    };
    validateFgidList = (rule, value, callback) => {
        if (this.props.match.params.type != "edit") {
            if (value) {
                if (value.length < 1) {
                    callback(new Error("请选择功能组"));
                } else {
                    callback();
                }
            } else {
                callback(new Error("请选择功能组"));
            }
        } else {
            callback();
        }
    };
    validateMonths = (rule, value, callback) => {
        if (!value) {
            callback(new Error("请填写购买月数"));
        } else {
            callback();
        }
    };
    //验证账号IMEI
    validateImei = (rule, value, callback) => {
        if (!value || /^[A-Za-z0-9]{12,16}$/.test(value)) {
            callback();
        } else {
            callback(new Error("请输入12~16位数字和字母IMEI号"));
        }
    };
    onClose(){
        this.setState({
            modalStartFlag:false,
            modalEndFlag:false
        })
    }
    onChange1 = (value) => {
        this.setState({ dateTime1:value });
    };
    onChange2 = (value) => {
        this.setState({ dateTime2:value });
    };
    affirm1(){
        this.setState({
            modalStartFlag:false,
            modalEndFlag:true
        })
    }
    affirm2(){
        if(Date.parse(this.state.dateTime1)>Date.parse(this.state.dateTime2)){
            Toast.fail('结束时间不能小于开始时间',1)
            return;
        }
        if((Date.parse(this.state.dateTime2)-Date.parse(this.state.dateTime1))>3600000){
            Toast.fail('查询时间不能超过1小时',1)
            return;
        }
        this.setState({
            modalEndFlag:false,
            startTime:formDateTime(this.state.dateTime1),
            endTime:formDateTime(this.state.dateTime2)
        },()=>{
            axios.post('/api/location/trackPlayback',{
                uids:[this.props.match.params.id],
                startTime:this.state.startTime,
                endTime:this.state.endTime
            })
            .then(res=>{
                console.log(res)
                if(res.status==200){
                    if(JSON.stringify(res.data)=='{}'){
                        Toast.fail('该用户在一小时内没有上报位置！',2)
                        return;
                    }
                    else if(res.data[this.props.match.params.id].length==1){
                        Toast.fail('该用户在一小时内只上报了一次位置！',2)
                        return;
                    }
                    else{
                        this.props.history.push(`/locationMsg/${this.props.match.params.id}/1/${JSON.stringify(res.data[this.props.match.params.id])}`)
                    }
                }
                else{
                    Toast.fail(res.message,2)
                }
            })
        })
    }
    goLocaltion(type){
        if(type==1){
            this.setState({
                modalStartFlag:true
            })
        }
        if(type==2){
            this.props.history.push(`/locationMsg/${this.props.match.params.id}/2`)
        }
    }
    render() {
        const {
            getFieldProps,
            getFieldError,
            setFieldsValue,
        } = this.props.form;
        const {
            type,
            drawerLeft,
            drawerLeftDefault,
            userInfo,
            showValidateMonths,
            preValidateMonth,
            totalPrice,
            permanentTotalPrice,
            hideDeleteBtn,
            renewType,
            funcs2,
            checkRadioItem,
            userValidYears
        } = this.state;
        const {
            groupsGidArr,
            groups,
            addDefaultGroup,
            defaultGroup,
            match,
            history,
            funcGroupList,
            form
        } = this.props;
        const {
            account,
            name,
            password,
            imei,
            deviceInfo,
            gpsInterval,
            remarks,
            usrType,
            funcsList,
        } = userInfo;
        const {
            iccid,
        } = deviceInfo
        console.log('userInfo', userInfo)
        const userMsg =
            sessionStorage.getItem("loginMsg") &&
            JSON.parse(sessionStorage.getItem("loginMsg"));
        // 功能组勾选    
        const onChange = (e, id, item) => {
            console.log(e.target.checked, id);
            let arr = this.state.funcGidArr;
            if (e.target.checked) {
                arr.push(item);
            } else {
                arr.splice(arr.map(item => item.id).indexOf(id), 1);
            }
            // let isDiscount = arr.map(item => item.type).indexOf(1) >= 0;
            // this.setState({
            //     showValidateMonths: !isDiscount,
            // });
            this.setState({
                checkedFuncGidArr: arr,
            }, () => {
                sumTotalPrice();
            });
            setFieldsValue({
                funcsList: arr.map(item => item.id),
            });
        };
        const funcGroupPrice = (e,item) => {
          console.log('单选',item,)

          // 获取创建数量
          let userCount = form.getFieldValue('create_number')
          userCount = userCount ? userCount : 1
          // 所勾选的功能组币价格 单价
          let funcGroupPrice = item.pttAmount
          // 计算消耗的总币数: 功能组币价格 * 账号数
          let sumTotalPrice = funcGroupPrice
          sumTotalPrice *= userCount
          let totalPrice = 0
          let permanentTotalPrice = 0
          let userType = 0

          // 根据功能组类型判断使用的币类型
          let currencyType = item.currencyType
          if(currencyType == 4){
            userType= 4
            permanentTotalPrice = sumTotalPrice
          } else {
            userType= 0
            totalPrice = sumTotalPrice
          }

          this.setState({
            funcGroupPrice: funcGroupPrice, // 功能组单价
            checkRadioItem: item.id,
            months: item.months,
            currencyType: currencyType,
            userType: userType,
            totalPrice: totalPrice,
            permanentTotalPrice: permanentTotalPrice
          })
          setFieldsValue({
            funcsList: [item.id],
          })

        }
        const sumTotalPrice = () => {
            // let months = form.getFieldValue('validMonths');
            // let count = form.getFieldValue('create_number');
            // months = months ? months : 0;
            // const preferentialMonths = this.state.preValidateMonth;
            // if (preferentialMonths > 0) {
            //     months = 36 / preferentialMonths;
            // }
            // count = count ? count : 1;
            // let sumTotalPrice = 0;
            // this.state.checkedFuncGidArr.filter(item => {
            //     sumTotalPrice += item.pttAmount;
            // });
            // sumTotalPrice *= months * count
            // this.setState({
            //     totalPrice: sumTotalPrice.toString(),
            // })
            let userCount = form.getFieldValue('create_number')
            userCount = userCount ? userCount : 1
            let sumTotalPrice = this.state.funcGroupPrice
            sumTotalPrice *= userCount
            let totalPrice = 0
            let permanentTotalPrice = 0
            // 判断使用虚拟币/终身币
            if (this.state.currencyType == 4){
                permanentTotalPrice = sumTotalPrice
            } else {
                totalPrice = sumTotalPrice
            }
            this.setState({
                totalPrice: totalPrice,
                permanentTotalPrice: permanentTotalPrice
            })
        };
        const onSingleCall = (e) => {
            console.log(e.target.checked);
            this.setState({
                funcValueList: e.target.checked ? [0,1,3,9] : [],
            })
        };
        return (
            <div className="adduser">
                <div className="header-sticky">
                    <NavBar
                        icon={<Icon type="left" />}
                        onLeftClick={() => history.goBack()}
                    >
                        {type == "edit" ? "修改用户" : "添加用户"}
                    </NavBar>
                </div>
                <div className="sub-container">
                    <form>
                        <List
                            renderFooter={() =>
                                getFieldError("account") ||
                                getFieldError("name") ||
                                getFieldError("password") ||
                                getFieldError("gpsInterval") ||
                                getFieldError("create_number") ||
                                getFieldError("joinGids") ||
                                getFieldError("defaultGid") ||
                                getFieldError("defaultCheckboxItem") ||
                                getFieldError("funcsList") ||
                                getFieldError("validMonths") ||
                                getFieldError("imei")
                            }
                        >
                            {/* 账号 */}
                            <InputItem
                                {...getFieldProps("account", {
                                    rules: [
                                        {
                                            validator: this.validateAccount,
                                        },
                                    ],
                                    initialValue: account,
                                })}
                                clear
                                placeholder="最大长度16，支持字母、数字"
                                key="2"
                                maxLength="16"
                                minLength="2"
                            >
                                <i className="red-star">*</i>
                                账号
                            </InputItem>
                            {/* 名称 */}
                            <InputItem
                                {...getFieldProps("name", {
                                    rules: [
                                        {
                                            validator: this.validateName,
                                        },
                                    ],
                                    initialValue: name,
                                })}
                                clear
                                key="3"
                                maxLength="16"
                                minLength="2"
                            >
                                名字
                            </InputItem>
                            {/* 密码 */}
                            {(loginAdminMsg && loginAdminMsg.userType == 4 && this.props.match.params.type == "edit"
                                && loginAdminMsg.preferentialMonths > 0 && !loginAdminMsg.permissionCodeList.includes(203)) ? (
                                ""
                            ) : (<InputItem
                                {...getFieldProps("password", {
                                    rules: [
                                        { validator: this.validatePassword },
                                    ],
                                    initialValue: password,
                                })}
                                clear
                                error={!!getFieldError("password")}
                                placeholder="6-12位数字、字母组合"
                                key="4"
                                maxLength="12"
                                type={type == "edit" ? "text" : "password"}
                            >
                                <i className="red-star">*</i>
                                    密码
                            </InputItem>)}
                            {/* imei */}
                            <InputItem
                                {...getFieldProps("imei", {
                                    rules: [
                                        {
                                            validator: this.validateImei,
                                        },
                                    ],
                                    initialValue: imei,
                                })}
                                clear
                                key="6"
                                maxLength={16}
                                disabled={usrType == 3}
                            >
                                IMEI号
                            </InputItem>
                            {/* iccid */}
                            <InputItem
                                {...getFieldProps("iccid", {initialValue: deviceInfo.iccid})}
                                clear
                                maxLength={16}
                                disabled
                            >
                                ICCID
                            </InputItem>
                            {/* GPS周期 */}
                            <Picker
                                {...getFieldProps("gpsInterval", {
                                    rules: [
                                        {
                                            validator: this.validateGpsinterval,
                                        },
                                    ],
                                    initialValue: [gpsInterval],
                                })}
                                data={GpsInterval}
                                cols={1}
                                key="7"
                                error={!!getFieldError("gpsInterval")}
                            >
                                <Item key="1" arrow="horizontal">
                                    <i className="red-star">*</i>
                                    GPS周期
                                </Item>
                            </Picker>
                            {/* 权限 */}
                            {/* <CheckboxItem
                                checked={this.state.funcValueList.includes(3)}
                                onChange={e => onSingleCall(e)}
                            >
                                单呼
                            </CheckboxItem> */}
                            <List renderHeader="权限">
                              <CheckboxItem
                                {...getFieldProps('defaultCheckboxItem')}
                                checked={this.state.funcValueList.includes(0)}
                                onChange={e => onSingleCall(e,1)}
                              >
                                会话
                              </CheckboxItem>
                              <CheckboxItem
                                onChange={e => onSingleCall(e, 2)}
                                checked={this.state.funcValueList.includes(1)}
                              >
                                切组
                              </CheckboxItem>
                              <CheckboxItem
                                onChange={e => onSingleCall(e, 3)}
                                checked={this.state.funcValueList.includes(2)}
                              >
                                单呼
                              </CheckboxItem>
                              <CheckboxItem
                                onChange={e => onSingleCall(e, 4)}
                                checked={this.state.funcValueList.includes(9)}
                              >
                                跨组单呼
                              </CheckboxItem>
                            </List>
                            {this.props.match.params.type == "edit" ? (
                                ""
                            ) : (
                                <div>
                                    <InputItem
                                        {...getFieldProps("create_number", {
                                            rules: [
                                                {
                                                    validator: this.validateCreateNumber,
                                                },
                                            ],
                                            initialValue: 1,
                                        })}
                                        clear
                                        error={!!getFieldError("create_number")}
                                        placeholder="用于批量添加，范围:1~500"
                                        disabled={this.state.type == "edit"}
                                        maxLength="3"
                                        onBlur={sumTotalPrice}
                                    >
                                        账号数
                                    </InputItem>
                                    <InputItem
                                        {...getFieldProps("initNo", {
                                            initialValue: "",
                                        })}
                                        key="8"
                                        maxLength="5"
                                        clear
                                    >
                                        开始账号
                                    </InputItem>
                                </div>
                            )}
                            <InputItem
                                {...getFieldProps("joinGids", {
                                    rules: [
                                        {
                                            validator: this.validateInGroups,
                                        },
                                    ],
                                    initialValue: groupsGidArr,
                                })}
                                className="hide-input"
                                value={groupsGidArr}
                                arrow="horizontal"
                                extra={
                                    <span
                                        onClick={() =>
                                            this.setState({ drawerLeft: 0 })
                                        }
                                    >
                                        {groupsGidArr.length < 1
                                            ? `点击选择群组`
                                            : `已选择${groupsGidArr.length}个群组`}
                                    </span>
                                }
                                key="15"
                                onClick={() => this.setState({ drawerLeft: 0 })}
                                editable="false"
                            >
                                <i className="red-star">*</i>
                                所属群组
                            </InputItem>
                            <InputItem
                                {...getFieldProps("defaultGid", {
                                    rules: [
                                        {
                                            validator: this.validateDefaultGid,
                                        },
                                    ],
                                    initialValue: defaultGroup.gid,
                                })}
                                className="hide-input"
                                value={defaultGroup}
                                arrow="horizontal"
                                extra={
                                    <div
                                        style={{
                                            textAlign: " right",
                                            width: "50vw",
                                            minWidth: "100px",
                                            height: "16px",
                                        }}
                                        onClick={() => {
                                            console.log(
                                                groupsGidArr,
                                                defaultGroup,
                                            );
                                            if (groupsGidArr.length < 1) {
                                                Toast.info(
                                                    "请先选择所属群组",
                                                    1.5,
                                                );
                                            } else {
                                                this.setState({
                                                    drawerLeftDefault: 0,
                                                });
                                            }
                                        }}
                                    >
                                        {defaultGroup && defaultGroup.name
                                            ? defaultGroup.name
                                            : `请选择默认群组`}
                                    </div>
                                }
                                key="14"
                                editable="false"
                            >
                                <i className="red-star">*</i>
                                默认群组
                            </InputItem>
                            <TextareaItem
                                {...getFieldProps("remarks", {
                                    initialValue: remarks,
                                })}
                                title="备注"
                                placeholder=""
                                autoHeight
                                maxLength="100"
                            />
                            <List renderHeader="功能组">
                                <Accordion>
                                    <Accordion.Panel
                                        header={
                                            <div>
                                                <span className="red-star">
                                                    *
                                                </span>
                                                功能组
                                            </div>
                                        }
                                        {...getFieldProps("funcsList", {
                                            rules: [
                                                {
                                                    validator: this
                                                        .validateFgidList,
                                                },
                                            ],
                                        })}
                                    >
                                        <List className="my-list">
                                            {[...funcGroupList, ...funcs2].map(item => {
                                                console.log('功能', item)
                                                if (this.props.match.params.type == "edit"){
                                                    if ((funcsList &&
                                                            funcsList.indexOf(
                                                                String(item.id),
                                                            ) >= 0) ||
                                                        item.id < 0
                                                    ) {
                                                        return (
                                                            <List.Item
                                                                key={item.id}
                                                            >
                                                                {item.name}
                                                            </List.Item>
                                                        );
                                                    }
                                                } else {
                                                    return (
                                                        <RadioItem
                                                          key={item.id}
                                                          value={item}
                                                          checked={checkRadioItem === item.id}
                                                          onChange={e => {
                                                            funcGroupPrice(e,item)
                                                          }}
                                                        >
                                                          {item.name}
                                                        </RadioItem>
                                                    );
                                                }
                                            })}
                                        </List>
                                    </Accordion.Panel>
                                </Accordion>
                            </List>
                            {this.props.match.params.type != "edit" ? (
                                <InputItem
                                    {...getFieldProps("validMonths", {
                                        rules: [
                                            {
                                                validator: this.validateMonths,
                                            },
                                        ],
                                        initialValue: 
                                            preValidateMonth > 0
                                                ? (userValidYears == 1 ? 12 : this.state.months)
                                                : 12,
                                    })}
                                    type="number"
                                    defaultValue={12}
                                    disabled={preValidateMonth > 0}
                                    onBlur={sumTotalPrice}
                                    clear
                                >
                                    <i className="red-star">*</i>
                                    购买月数 
                                </InputItem>
                            ) : (
                                ""
                            )}
                            {!(this.props.match.params.type == "edit") ? (
                                <List.Item>
                                    消耗币数量
                                    <Badge text={'虚拟币: ' + totalPrice}
                                        style={{ padding: '0 3px', backgroundColor: '#fff', color: '#108ee9', borderRadius: 2, border: '1px solid #108ee9', }} />
                                    <Badge text={'终身币: ' + permanentTotalPrice}
                                        style={{ padding: '0 3px', backgroundColor: '#fff', color: '#108ee9', borderRadius: 2, border: '1px solid #108ee9', }} />
                                </List.Item>) : ("")}
                        </List>
                        <WhiteSpace />
                        <WhiteSpace />
                        <WingBlank>
                            {userMsg.userType * 100 == 400 ? (
                                this.props.match.params.type == "edit" ? (
                                    <div>
                                        {loginAdminMsg && loginAdminMsg.preferentialMonths <= 0 ||
                                            (loginAdminMsg && loginAdminMsg.permissionCodeList.includes(204) && userInfo.type != 3) ? (
                                            <div>
                                                <Button
                                                    type="warning"
                                                    onClick={() =>
                                                        history.push(
                                                            `/remotewrite/${match.params.id}`,
                                                        )
                                                    }
                                                >
                                                    远程放号
                                                    </Button>
                                                <WhiteSpace />
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                        {loginAdminMsg && loginAdminMsg.preferentialMonths <= 0 ||
                                            (loginAdminMsg && loginAdminMsg.permissionCodeList.includes(201)) ? (
                                            <div>
                                                <Button
                                                    type="primary"
                                                    onClick={() => this.submitBtn()}
                                                >
                                                    修改
                                                </Button>
                                                <WhiteSpace />
                                            </div>
                                        ) : ("")}

                                        <Button
                                            type="primary"
                                            onClick={() =>
                                                this.props.history.push(
                                                    `/userfriend/${userInfo.uid}`,
                                                )
                                            }
                                        >
                                            好友
                                        </Button>
                                        <WhiteSpace />
                                        <Button
                                            type="primary"
                                            onClick={() =>
                                                this.props.history.push(
                                                    `/funcDetail/user/${userInfo.uid}`,
                                                )
                                            }
                                        >
                                            功能组
                                        </Button>
                                        <WhiteSpace />
                                        <Button
                                            type="primary"
                                            onClick={() =>{
                                                // console.log('续',userInfo.oldType)
                                                if(userInfo.oldType == 0 || userInfo.oldType == 6){
                                                    this.props.history.push(
                                                    `/userFuncRenew/${userInfo.uid}/${renewType}/${userInfo.oldType}`,
                                                    )
                                                } else {
                                                    Toast.info('终身类型不支持续费!')
                                                }
                                                
                                            } 
                                            }
                                        >
                                            续费
                                        </Button>
                                        <WhiteSpace />
                                        {loginAdminMsg && loginAdminMsg.permissionCodeList.includes(205) ? (
                                            <Button
                                                type="primary"
                                                onClick={() =>
                                                    this.props.history.push(
                                                        `/setFunctions/${userInfo.uid}`,
                                                    )
                                                }
                                            >
                                                功能
                                            </Button>) : ('')}
                                        <WhiteSpace />
                                        <Button
                                            type="primary"
                                            onClick={() =>
                                                this.props.history.push(
                                                    `/setIccids/${userInfo.uid}`,
                                                )
                                            }
                                        >
                                            ICCID
                                        </Button>
                                        <WhiteSpace />
                                        {hideDeleteBtn ? ('') : (
                                            <Button
                                                type="warning"
                                                onClick={() => this.deleteBtn()}
                                            >
                                                删除
                                            </Button>
                                        )}
                                        {/* {loginAdminMsg && loginAdminMsg.permissionCodeList.includes(202)
                                            && !moment(userInfo.createDate).isBefore(moment(new Date()).subtract('days', 7)) ? (
                                                <Button
                                                    type="warning"
                                                    onClick={() => this.deleteUser()}
                                                >
                                                    删除
                                        </Button>) : ('')} */}
                                    </div>
                                ) : (
                                    <Button
                                        type="primary"
                                        onClick={() => this.submitBtn()}
                                    >
                                        确定
                                    </Button>
                                )
                            ) : (
                                ""
                            )}
                        </WingBlank>
                        <WhiteSpace />
                        <WhiteSpace />
                        <WhiteSpace />
                    </form>
                </div>
                <div
                    style={{
                        ...selectedContainer,
                        left: drawerLeft + "px",
                    }}
                >
                    <UserSelectGroups
                        defaultGroup={defaultGroup}
                        addDefaultGroup={addDefaultGroup}
                        uid={match.params.id}
                        handleChildClose={() =>
                            this.setState({
                                drawerLeft: document.body.clientWidth,
                            })
                        }
                    />
                </div>
                <div
                    style={{
                        ...selectedContainer,
                        left: drawerLeftDefault + "px",
                        overflowY: "scroll",
                        paddingBottom: "45",
                    }}
                >
                    <DefaultGroup
                        selectList={groups}
                        addDefaultGroup={addDefaultGroup}
                        defaultGroup={defaultGroup}
                        handleChildClose={() => {
                            this.setState({
                                drawerLeftDefault: document.body.clientWidth,
                            });
                        }}
                    />
                </div>
                <Modal
                    popup
                    visible={this.state.modalStartFlag}
                    onClose={this.onClose=this.onClose.bind(this)}
                    animationType="slide-up"
                    >
                        <div style={{display:'flex',justifyContent:'space-between',height:'40px',alignItems:'center',padding:'0 10px'}}>
                            <div onClick={()=>{this.setState({modalStartFlag:false})}}>取消</div>
                            <div>选择开始时间</div>
                            <div onClick={this.affirm1=this.affirm1.bind(this)}>确定</div>
                        </div>
                        <DatePickerView
                            value={this.state.dateTime1}
                            onChange={this.onChange1}
                        />
                </Modal>
                <Modal
                    popup
                    visible={this.state.modalEndFlag}
                    onClose={this.onClose=this.onClose.bind(this)}
                    animationType="slide-up"
                    >
                        <div style={{display:'flex',justifyContent:'space-between',height:'40px',alignItems:'center',padding:'0 10px'}}>
                            <div onClick={()=>{this.setState({modalEndFlag:false})}}>取消</div>
                            <div>选择结束时间</div>
                            <div onClick={this.affirm2=this.affirm2.bind(this)}>确定</div>
                        </div>
                        <DatePickerView
                            value={this.state.dateTime2}
                            onChange={this.onChange2}
                        />
                </Modal>
            </div>
        );
    }
}

const AddUserForm = createForm()(AddUser);
const mapStateToProps = state => {
    return {
        groups: state.group.groups,
        groupsGidArr: state.group.groupsGidArr,
        defaultGroup: state.group.defaultGroup,
        funcGroupList: state.app.funcGroupList,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        getFuncList: () => {
            dispatch({
                type: "app/getFuncGroupList",
                payload: {},
            });
        },
        addDefaultGroup: group => {
            dispatch({
                type: "group/addToDefaultGroup",
                payload: {
                    group,
                },
            });
        },
        setGroups: data => {
            dispatch({
                type: "group/setGroups",
                data,
            });
        },
        emptyGroups: () => {
            dispatch({
                type: "group/emptyGroups",
            });
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddUserForm);
